import { render, staticRenderFns } from "./ppt.vue?vue&type=template&id=568c6425&scoped=true"
import script from "./ppt.vue?vue&type=script&lang=js"
export * from "./ppt.vue?vue&type=script&lang=js"
import style0 from "./ppt.vue?vue&type=style&index=0&id=568c6425&prod&scoped=true&lang=css"
import style1 from "./ppt.vue?vue&type=style&index=1&id=568c6425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c6425",
  null
  
)

export default component.exports